import throttle from 'lodash/throttle';
import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import Reducers from './reducers';

const name = 'carfillo';

export const load_state = () => {
  try {
    const serialized_state = localStorage.getItem(`${name}`);
    if (serialized_state === null) {
      return undefined;
    }
    return JSON.parse(serialized_state);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error: Load State Error : ', e);
    return undefined;
  }
};

export const save_state = (state) => {
  try {
    const serialized_state = JSON.stringify(state);
    localStorage.setItem(`${name}`, serialized_state);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error: Save State Error : ', e);
    return undefined;
  }
  return undefined;
};

// Redux Middleware
const persisted_state = load_state();
const store = createStore(Reducers, persisted_state, composeWithDevTools());
store.subscribe(
  throttle(() => {
    save_state({
      Cart: store.getState().Cart,
      Login: store.getState().Login
    });
  }, 1000)
);

export default store;
